// Italian. Keys omitted here fall back to English (see src/i18n/index.js).
// "RPilot" is a brand name and stays untranslated.
export default {
  'common.cancel': 'Annulla',
  'common.submit': 'Invia',
  'common.save': 'Salva',
  'common.create': 'Crea',
  'common.delete': 'Elimina',
  'common.close': 'Chiudi',
  'common.retry': 'Riprova',
  'common.confirm': 'Conferma',
  'common.areYouSure': 'Sei sicuro?',

  'chat.startConversation': 'Inizia una conversazione',
  'chat.inputPlaceholder': 'Scrivi un messaggio...',
  'chat.inputPlaceholderNoCredits': 'Crediti RPilot esauriti',
  'chat.creditsUsedUpFooter': 'I crediti RPilot del tuo team sono esauriti. Avvia una nuova chat quando i crediti saranno rinnovati.',
  'chat.newChat': 'Nuova chat',
  'chat.useSkill': 'Usa una skill',
  'chat.skills': 'Skill',
  'chat.loadingSkills': 'Caricamento skill…',
  'chat.noSkill': 'Nessuna skill',
  'chat.noSkillsAvailable': 'Nessuna skill disponibile',
  'chat.appliesNextMessage': 'Si applica dal tuo prossimo messaggio',
  'chat.attachImage': 'Allega immagine',
  'chat.attachFile': 'Allega file',
  'chat.fileTooLarge': 'File troppo grande (max {size})',
  'chat.uploadFailed': 'Caricamento non riuscito',
  'chat.download': 'Scarica',
  'chat.recordVoice': 'Registra vocale',
  'chat.stopRecording': 'Interrompi registrazione',
  'chat.stop': 'Interrompi',
  'chat.send': 'Invia',
  'chat.thinking': 'Sto pensando…',
  'chat.thoughtProcess': 'Processo di ragionamento',
  'chat.waitingForHost': 'In attesa della dashboard…',
  'chat.thinkingComplete': 'Ragionamento completato',
  'chat.toolUsedOne': '1 strumento usato',
  'chat.toolsUsedCount': '{count} strumenti usati',
  'chat.usedNames': 'Usati {names}',
  'chat.usedToolsCount': 'Usati {count} strumenti',
  'chat.running': 'in esecuzione',
  'chat.details': 'Dettagli',
  'chat.arguments': 'Argomenti',
  'chat.result': 'Risultato',
  'chat.error': 'Errore',
  'chat.done': 'Fatto',
  'chat.openInNewTab': 'Apri in una nuova scheda',
  'chat.openInDocsSite': 'Apri nel sito di documentazione',
  'chat.noPageContent': 'Nessun contenuto disponibile per questa pagina.',
  'chat.goodResponse': 'Buona risposta',
  'chat.badResponse': 'Risposta scadente',
  'chat.whatWentWrong': 'Cosa è andato storto?',
  'chat.optionalFeedback': 'Feedback facoltativo...',

  'approval.required': 'Approvazione richiesta',
  'approval.requiredCount': 'Approvazione richiesta — {count} azioni',
  'approval.approve': 'Approva',
  'approval.deny': 'Rifiuta',
  'approval.approveAll': 'Approva tutto',
  'approval.approveSelected': 'Approva selezionati ({count})',
  'approval.denyAll': 'Rifiuta tutto',
  'approval.andMore': '…e altri {count}',
  'approval.approvedChip': 'Approvato',
  'approval.deniedChip': 'Rifiutato',
  'approval.timedOutChip': 'Scaduto',
  'approval.countApproved': '{count} approvate',
  'approval.countDenied': '{count} rifiutate',
  'approval.countTimedOut': '{count} scadute',
  'approval.timedOut': 'scaduto',
  'approval.settled': 'gestito',

  'header.expand': 'Espandi',
  'header.collapse': 'Comprimi',
  'header.menu': 'Menu',
  'drawer.sessions': 'Sessioni',
  'drawer.skills': 'Skill',
  'drawer.settings': 'Impostazioni',
  'drawer.noSessions': 'Ancora nessuna sessione',
  'drawer.chatFallbackTitle': 'Chat {id}',
  'drawer.newSkill': 'Nuova skill',
  'drawer.searchSkills': 'Cerca skill...',
  'drawer.noSkillsMatch': 'Nessuna skill corrisponde alla ricerca.',
  'drawer.noSkillsYet': 'Ancora nessuna skill. Creane una per iniziare.',
  'drawer.mySkills': 'Le mie skill',
  'drawer.builtIn': 'Integrate',
  'drawer.shared': 'Condivise',
  'drawer.showToolCalls': 'Mostra chiamate agli strumenti',
  'drawer.autoAcceptEdits': 'Accetta automaticamente le modifiche',
  'drawer.darkMode': 'Modalità scura',
  'drawer.version': 'Versione',
  'drawer.versionCopied': 'Copiato',

  'gate.meetTitle': 'Scopri RPilot',
  'gate.meetBody': "RPilot è il tuo assistente IA per RDrive. Fai domande su disegni, problemi, programmi e dati di progetto in linguaggio comune e ottieni risposte chiare con link diretti all'app.",
  'gate.meetCta': 'Vuoi RPilot per il tuo team? Contatta il nostro team commerciale',
  'gate.outOfCreditsTitle': 'I tuoi crediti RPilot sono esauriti',
  'gate.outOfCreditsBody': 'I crediti RPilot del tuo team sono esauriti. Contattaci per rinnovarli e riprendere da dove eri rimasto.',
  'credits.title': 'Utilizzo crediti',
  'credits.loadFailed': "Impossibile caricare l'utilizzo dei crediti.",
  'credits.active': 'Attivo',
  'credits.fallback': 'Riserva',
  'credits.exhausted': 'esaurito',
  'credits.noPools': 'Nessun pool di crediti',
  'credits.daily': 'Giornaliero',
  'credits.weekly': 'Settimanale',
  'credits.monthly': 'Mensile',
  'credits.dayShort': 'G',
  'credits.weekShort': 'S',
  'credits.monthShort': 'M',
  'credits.usedNoLimit': '{label} — {spent} usati (senza limite)',
  'credits.balanceLine': 'Saldo: {balance} crediti · si azzera a mezzanotte {zone}',
  'credits.account': 'Account',
  'credits.scopeProject': 'Progetto',
  'credits.scopeTeam': 'Team',
  'credits.scopeMixed': 'Misto',
  'credits.scopePool': 'Pool',
  'credits.messageNotSent': 'I crediti RPilot del tuo team sono esauriti, quindi questo messaggio non è stato inviato. La conversazione è stata salvata.',
  'credits.contactUs': 'Contattaci',

  'sales.contactSales': 'Contatta le vendite',
  'sales.requestReceived': 'Richiesta ricevuta ✓',
  'sales.submitAgain': 'Invia di nuovo',
  'sales.name': 'Nome',
  'sales.workEmail': 'Email di lavoro',
  'sales.companyTeam': 'Azienda / team (facoltativo)',
  'sales.message': 'Messaggio (facoltativo)',
  'sales.nameRequired': 'Il nome è obbligatorio',
  'sales.emailRequired': "L'email di lavoro è obbligatoria",
  'sales.emailInvalid': 'Inserisci un indirizzo email valido',
  'sales.thanks': 'Grazie — il nostro team ti contatterà.',
  'sales.alreadyReceived': 'Abbiamo già ricevuto la tua richiesta — ti contatteremo.',
  'sales.genericError': 'Qualcosa è andato storto. Riprova.',
  'sales.speakWithSales': 'Parla con il team di vendita',
  'sales.salesChatPrefill': 'Salve, vorrei parlare con il team di vendita riguardo a RPilot per il mio team.',


  'skill.newSkill': 'Nuova skill',
  'skill.editTitle': 'Modifica — {name}',
  'skill.viewTitle': '{name}',
  'skill.readOnlyHint': 'Questa è una skill integrata gestita da RDrive e non può essere modificata. Per personalizzarla per questo progetto, crea una skill condivisa con lo stesso nome — avrà la precedenza qui.',
  'skill.name': 'Nome',
  'skill.nameHint': 'identificatore kebab-case',
  'skill.nameRule': 'Deve essere in kebab-case (es. review-rfi)',
  'skill.shared': 'Condivisa',
  'skill.description': 'Descrizione',
  'skill.descriptionPlaceholder': 'Cosa fa questa skill e quando usarla',
  'skill.required': 'Obbligatorio',
  'skill.tags': 'Tag',
  'skill.tagsPlaceholder': 'Digita e premi Invio',
  'skill.allowedTools': 'Strumenti consentiti',
  'skill.allToolsAllowed': 'Tutti gli strumenti consentiti',
  'skill.instructions': 'Istruzioni (Markdown)',
  'skill.contentRequired': 'Il contenuto è obbligatorio',
  'skill.deleteTitle': 'Elimina skill',
  'skill.deleteMessage': 'Eliminare la skill "{name}"? L\'operazione non può essere annullata.',

  'picker.selectLocation': 'Seleziona posizione',
  'picker.searchDrawings': 'Cerca disegni...',
  'picker.planViewerFailed': 'Impossibile caricare il visualizzatore di tavole',
  'picker.selectDrawing': 'Seleziona un disegno da visualizzare',
  'picker.tapToPlace': 'Tocca un segnaposto per posizionare il problema',
  'picker.pinPlaced': 'Segnaposto posizionato',

  'md.bold': 'Grassetto',
  'md.italic': 'Corsivo',
  'md.heading': 'Titolo',
  'md.inlineCode': 'Codice inline',
  'md.codeBlock': 'Blocco di codice',
  'md.link': 'Link',
  'md.bulletList': 'Elenco puntato',
  'md.numberedList': 'Elenco numerato',
  'md.blockquote': 'Citazione',
  'md.nothingToPreview': 'Niente da visualizzare in anteprima',
}
